import elements from './elements';
import anchors from './anchors';

export default {
  elements,
  anchors,
};
